// extracted by mini-css-extract-plugin
export default {"container":"not-allowed_container__zA060","content":"not-allowed_content__r0fH5","title":"not-allowed_title__2C7R8"};